<table class="missing-cards table" mat-table [dataSource]="dataSourceMissingCards" multiTemplateDataRows matSort>
	<tr mat-header-row *matHeaderRowDef="customerColumns"></tr>
	<tr
		mat-row
		*matRowDef="let element; columns: customerColumns"
		#customerRow
		(click)="toggleRow(element)"
		[ngClass]="{ expanded: isExpanded(element), collapsed: !isExpanded(element) }"
	></tr>
	<tr mat-row *matRowDef="let row; columns: ['expandedDetail']"></tr>

	<!--First Layer-->
	<ng-container class="table-container">
		<ng-container matColumnDef="Customers">
			<th mat-header-cell *matHeaderCellDef>Customers</th>
			<td mat-cell class="customer-data first-collumn customerName" *matCellDef="let element">
				<span
					[matTooltip]="element.customerDetails.name"
					[matTooltipPosition]="'above'"
					[matTooltipClass]="'tooltip-missingCard'"
					class="text"
					>{{ element.customerDetails.name }}</span
				>
			</td>
		</ng-container>

		<ng-container matColumnDef="Paygroups">
			<th mat-header-cell *matHeaderCellDef class="second-collumn">Paygroups</th>
			<td class="customer-data second-collumn paygroupName" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.payGroups.length > 1">{{ element.payGroups.length }} Paygroups</span>
				<span class="text" *ngIf="element.payGroups.length < 2">{{ element.payGroups.length }} Paygroup</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="Missing Cards">
			<th mat-header-cell *matHeaderCellDef>Missing Cards</th>
			<td class="customer-data third-collumn missing-card-count" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.totalMissingCardCount > 1"
					>{{ element.totalMissingCardCount }} Missing cards</span
				>
				<span class="text" *ngIf="element.totalMissingCardCount < 2"
					>{{ element.totalMissingCardCount }} Missing card</span
				>
			</td>
		</ng-container>

		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
			<td mat-cell *matCellDef="let element" class="button-container fourth-collumn customer-data">
				<button
					#expand
					mat-icon-button
					class="drop-down-arrow-button"
					aria-label="expand row"
					(click)="toggleRow(element); $event.stopPropagation()"
					element="element"
				>
					<app-icon
						class="drop-down-arrow"
						[ngClass]="{ down: isExpanded(element) }"
						[size]="'18px'"
						[lineWidth]="'2.5px'"
						[name]="'arrow-down'"
					></app-icon>
				</button>
			</td>
		</ng-container>
	</ng-container>

	<!--Second Layer-->
	<ng-container class="paygroup-container" matColumnDef="expandedDetail">
		<td
			mat-cell
			*matCellDef="let element"
			class="paygroup-row"
			[ngClass]="{
				'paygroups-expanded': isExpanded(element)
			}"
			[attr.colspan]="paygroupsColumns.length"
		>
			<div class="paygroup-detail" *ngIf="element.payGroups.length" [@detailExpand]="expandedState(element)">
				<div class="inner-table">
					<table
						class="paygroup-table"
						#innerTables
						mat-table
						[dataSource]="element.payGroups"
						multiTemplateDataRows
						matSort
					>
						<ng-container matColumnDef="first-padding">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="padding first-collumn" mat-cell *matCellDef="let element">
								<span class="first padding text">{{ element.payGroupDetails.name }}</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="Paygroups">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="paygroup-text second-collumn paygroupName" mat-cell *matCellDef="let element">
								<span
									class="payGroup-name text"
									[matTooltip]="
										element.legalEntityExternalId +
										' ' +
										element.payGroupDetails.name +
										' ' +
										element.payGroupDetails.externalId
									"
									[matTooltipPosition]="'above'"
									[matTooltipClass]="'tooltip-missingCard'"
								>
									<img
										src="assets/svg-country-flags/svg/{{
											element.payGroupDetails.country?.toLowerCase()
										}}.svg"
									/>

									{{ element.legalEntityExternalId }} {{ element.payGroupDetails.name }}
									{{ element.payGroupDetails.externalId }}</span
								>
							</td>
						</ng-container>

						<ng-container matColumnDef="Missing Cards">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td
								class="paygroup-text third-collumn missing-cards-count"
								mat-cell
								*matCellDef="let element"
							>
								<span class="text" *ngIf="element.missingCardCount > 1"
									>{{ element.missingCardCount }} Missing cards</span
								>
								<span class="text" *ngIf="element.missingCardCount < 2"
									>{{ element.missingCardCount }} Missing card</span
								>
							</td>
						</ng-container>

						<ng-container matColumnDef="second-padding">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let element" class="padding fourth-collumn">
								<button
									mat-icon-button
									class="drop-down-arrow-button padding"
									aria-label="expand row"
									element="element"
								>
									<app-icon
										class="drop-down-arrow"
										[ngClass]="{ down: isExpanded(element) }"
										[size]="'18px'"
										[lineWidth]="'2.5px'"
										[name]="'arrow-down'"
									></app-icon>
								</button>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="paygroupsColumns"></tr>
						<tr
							mat-row
							*matRowDef="let row; columns: paygroupsColumns"
							(click)="routeToEmployeeData(row)"
						></tr>
					</table>
				</div>
			</div>
		</td>
	</ng-container>
</table>
